module.exports = __webpack_public_path__ + "img/moodle-notifier-04.619afc73.png";